import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAsync, selectContasContabeis } from '../../features/conta-contabil/contaContabilSlice';
import QCXAutocompleteSelect from '../autocomplete-select/QCXAutocompleteSelect';

export default function QCXSelectContaContabilAutocomplete({
  label,
  name,
  initialValues,
  ...restProps
}) {
  const dispatch = useDispatch();
  const rawList = useSelector(selectContasContabeis);
  const list = useMemo(() => rawList.filter((item) => item.active), [rawList]);
  // TODO
  // const configControl = useSelector(selectConfigControl);
  useEffect(() => {
    // TODO
    // if (isAutoLoadControl(configControl)) {
    //   dispatch(fetchAllAsync());
    // }
    dispatch(fetchAllAsync());
  }, []);

  const [defaultValue, setDefaultValue] = useState('');
  useEffect(() => {
    const value = list.find((item) => item.id === _.get(initialValues, name));
    if (value) {
      setDefaultValue(value);
    } else {
      setDefaultValue({ id: null, description: '' });
    }
  }, [list, initialValues]);

  const filterOptions = createFilterOptions({
    stringify: (item) => `${item.grau} - ${item.description}`,
  });
  return (
    <QCXAutocompleteSelect
      label={label}
      id={name}
      name={name}
      options={list}
      filterOptions={filterOptions}
      defaultValue={defaultValue}
      getOptionLabel={(item) => (item?.conta && item?.description ? `${item?.conta} - ${item?.description}` : '')}
      {...restProps}
    />
  );
}
